<!--
  ~ Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
  ~ This software is the proprietary information of NEXTWELL INTL SRL.
  ~ Use is subject to license and non-disclosure terms
  -->

<well-place-autocomplete [ngModel]='value()' (ngModelChange)='onValueChange($event)' [required]='required()'
                         [disabled]='disabled()' [label]='label()' data-testid="value-autocomplete"></well-place-autocomplete>


